export default __webpack_public_path__ + "static/media/project-icon.45654399.png";